import React, {Component} from 'react';
import {connect} from 'react-redux';

class Achievements extends Component {
    render() {
        return (<h3 style={{backgroundColor: '#fff'}}>Achievements</h3>)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {};
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
    };
};
export default (connect(mapStateToProps, mapDispatchToProps)(Achievements));


// WEBPACK FOOTER //
// ./src/components/achievements/index.js